module.exports = __webpack_public_path__ + "img/central.f88f3ab1.jpg";